import { gql } from "apollo-angular";

export const  SIF_THANK_YOU = gql`
  fragment SIF_THANK_YOU on SifThankYouMessage {
    header
    subhead
    hTag
    thankYouText
    linksCollection(limit:8) {
        items {
        ... LINK_FIELDS
        }
    }
      
  }`;
